import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';

function initTestimonials(region) {
    const swiperEl = region.querySelector('.swiper');
    if (!swiperEl || swiperEl.swiper) return;

    new Swiper(swiperEl, {
        modules: [Navigation, Pagination, A11y, Keyboard],
        // Mobile default; desktop restores 800 in `breakpoints` below. Swiper
        // merges breakpoint params over these and falls back to the originals
        // when no breakpoint matches, so `speed` round-trips on resize.
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 32,
        loop: true, 
        watchOverflow: true, 
        watchSlidesProgress: true,
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous testimonial',
            nextSlideMessage: 'Next testimonial',
            paginationBulletMessage: 'Go to testimonial {{index}}',
        },
        navigation: {
            prevEl: region.querySelector('[data-testimonials-prev]'),
            nextEl: region.querySelector('[data-testimonials-next]'),
        },
        pagination: {
            el: region.querySelector('[data-testimonials-pagination]'),
            clickable: true,
            renderBullet: (index, className) =>
                `<button type="button" class="${className}"><span></span></button>`,
        },
        breakpoints: {
            // Desktop: let the next slide peek in. Animation timing is
            // unchanged from the original design here (800ms + full-bounce
            // curve); only mobile was softened.
            1024: { slidesPerView: 1.4, spaceBetween: 64, speed: 800 },
        },
    });
}

function init() {
    document.querySelectorAll('[data-testimonials]').forEach(initTestimonials);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
